import { ChangeDetectionStrategy, Component, HostBinding, Input } from '@angular/core';
import { TranslatedString } from 'models/translated-string';

/** Which alert card's colours the chip takes; Neutral takes the gray badge's */
export enum StatusChipTone {
  Success = 'success',
  Warning = 'warning',
  Assertive = 'assertive',
  Neutral = 'neutral',
}

/**
 * The small round-ended result pill (#6676): "Target hit", "Same", "Down", "On track". It started
 * as the compact workout page's set-1 mark chip (#4142) and is shared so every screen draws a
 * good / bad judgement the same way. With `info` set, an info icon follows the label and opens
 * a tooltip, as `cs-badge [info]` does.
 */
@Component({
  selector: 'cs-status-chip',
  templateUrl: 'cs-status-chip.html',
  host: { 'class': 'status-chip' },
  standalone: false,
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class CsStatusChipComponent {
  @Input() tone: StatusChipTone = StatusChipTone.Neutral;
  @Input() label: TranslatedString;
  @Input() info?: TranslatedString;

  // the tone's colour class beside the static `status-chip` host class
  @HostBinding('class.success') get isSuccess() { return this.tone === StatusChipTone.Success; }
  @HostBinding('class.warning') get isWarning() { return this.tone === StatusChipTone.Warning; }
  @HostBinding('class.assertive') get isAssertive() { return this.tone === StatusChipTone.Assertive; }
  @HostBinding('class.neutral') get isNeutral() { return this.tone === StatusChipTone.Neutral; }
}
